// extracted by mini-css-extract-plugin
module.exports = {"container":"CBSearchInput_container__AO1lM","active":"CBSearchInput_active__2Hayo","label":"CBSearchInput_label__2bEy4","searchField":"CBSearchInput_searchField__3S1vy"};